import { render, staticRenderFns } from "./step.vue?vue&type=template&id=72915da0"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports